export default "__VITE_ASSET__M6MDpUZE__"